import React from 'react';
import { compose, withHandlers, withState, lifecycle, withPropsOnChange } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField } from 'redux-form-material-ui';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import InputLabel from '@material-ui/core/InputLabel';
import { Select as Select2, Checkbox } from 'redux-form-material-ui';
import { get, find /*, filter*/ } from 'lodash';
import { users as getAllUsers } from '../../users/_api';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import moment from 'moment';
import { getConfig } from '../_api';
import withLoader from '../../app/withLoader';
import { listProducts } from '../../products/_api';
import { allServices } from '../../services/_api';
import { categories as allCategories } from '../../categories/_api';
import { Autocomplete } from '../../../components/forms/Autocomplete';
import queryString from 'query-string';
import withCountPriceServeItem from '../../reservations/withCountPriceServeItem';

const styles = (theme) => ({
  paper: { padding: 15, marginBottom: 15, marginTop: 20 },
});

const required = (value) => (value || typeof value === 'number' ? undefined : 'Vyžadováno');

const enhance = compose(
  withStyles(styles),
  withRouter,
  withLoader,
  connect((state) => {
    const from = get(getFormValues('addReservationForm')(state), 'from', null);
    const to = get(getFormValues('addReservationForm')(state), 'to', null);
    return {
      type: get(getFormValues('addReservationForm')(state), 'type', null),
      userId: get(getFormValues('addReservationForm')(state), 'userId.value', null),
      personId: get(getFormValues('addReservationForm')(state), 'personId.value', null),
      from: from ? moment(from).format('YYYY-MM-DD 00:00:00') : null,
      to: to ? moment(to).format('YYYY-MM-DD 23:59:59') : null,
      addNewItem: get(getFormValues('addReservationForm')(state), 'addNewItem', null),
      itemsValue: get(getFormValues('addReservationForm')(state), 'items', null),
      isStocked: get(getFormValues('addReservationForm')(state), 'isStocked', null),
      serviceId: get(getFormValues('addReservationForm')(state), 'serviceId', null),
      isKnownUser: get(getFormValues('addReservationForm')(state), 'isKnownUser', null),
      adjustment: get(getFormValues('addReservationForm')(state), 'adjustment', null),
    };
  }),
  withState('users', 'setUsers', null),
  withState('persons', 'setPersons', null),
  withState('services', 'setServices', []),
  withState('servicesToShow', 'setServicesToShow', []),
  withState('items', 'setItems', []),
  withState('categories', 'setCategories', []),
  withState('config', 'setConfig', null),
  withState('configQR', 'setConfigQR', null),
  reduxForm({ form: 'addReservationForm' }),
  lifecycle({
    async componentDidMount() {
      const {
        setUsers,
        setServices,
        setServicesToShow,
        setCategories,
        setConfig,
        setConfigQR,
        location,
        loadPersons,
        change,
        toggleLoader,
      } = this.props;
      const parsed = queryString.parse(get(location, 'search'));
      toggleLoader();
      const [users, services, categories, config, config2] = await Promise.all([
        getAllUsers(),
        allServices(),
        allCategories(),
        getConfig({ config: 'SERVICE_ATTRIBUTES' }),
        getConfig({ config: 'QR_CODE' }),
      ]);
      setUsers(get(users, 'items', []));
      /*setServicesToShow(
        filter(get(services, 'items', []), (item) => {
          const check = +Number(item.flags).toString(2) & 0b1000;
          return check === 0b1000 ? true : false;
        })
      );*/
      setServicesToShow(get(services, 'items', []));
      setServices(get(services, 'items', []));
      setCategories(categories);
      setConfig(config);
      setConfigQR(config2);
      const userId = get(parsed, 'user');
      if (userId) {
        await loadPersons(parseInt(userId, 10), get(users, 'items', []));
        const userLabel = find(get(users, 'items', []), { id: parseInt(userId, 10) });
        change('userId', {
          value: parseInt(userId, 10),
          label: `${get(userLabel, 'surname') || ''} ${get(userLabel, 'forename') || ''}`,
        });
      }
      change('serviceId', 2);
      change('adjustment', true);
      toggleLoader(false);
    },
  }),
  withCountPriceServeItem,
  withHandlers({
    loadItems:
      ({ toggleLoader, setItems, serveItems }) =>
      async (categoryId) => {
        toggleLoader(true);
        const products = await listProducts(categoryId);
        setItems(serveItems(get(products, 'items', []), 'downhill', 1, true, categoryId));
        toggleLoader(false);
      },
  }),
  withPropsOnChange(['isStocked'], ({ isStocked, loadItems }) => {
    if (isStocked) {
      loadItems('LYZE');
    }
  })
);

export default enhance(
  ({
    classes,
    handleSubmit,
    setAddUser,
    setEdit,
    edit,
    history,
    users,
    type,
    items,
    userId,
    loadItems,
    from,
    to,
    renderMembers,
    loadPersons,
    onSubmit,
    personsValue,
    countDays,
    services,
    servicesToShow,
    categories,
    formItems,
    addNewItem,
    change,
    itemsValue,
    isStocked,
    serviceId,
    config,
    isKnownUser,
    configQR,
    adjustment,
    handleTabChange,
  }) => (
    <form
      className={classes.form}
      onSubmit={handleSubmit((values) => {
        const serviceId =
          values.adjustment && !values.serviceId
            ? get(find(services, { flags: 11 }), 'id')
            : values.serviceId;
        onSubmit({
          ...values,
          itemAdjustment: {
            ...values.itemAdjustment,
            version: get(configQR, 'suffix', '').substring(1),
          },
          serviceId,
          price: get(find(services, { id: serviceId }), 'alternativePrice') || 150,
        });
      })}
    >
      <Grid container spacing={8}>
        {/*<Grid item xs={12}>
          <FormControlLabel
            control={<Field name="isKnownUser" component={Checkbox} />}
            label="Zákazník z databáze"
          />
  </Grid>*/}
        {/*isKnownUser && (
          <Grid item xs={3}>
            <Field
              name="userId"
              component={(props) => (
                <Select
                  value={props.input.value}
                  onChange={(values, options) => {
                    props.input.onChange(values, options);
                  }}
                  onBlur={() => props.input.onBlur(props.input.value)}
                  options={sortBy(users, ['surname']).map((item) => ({
                    value: item.id,
                    label: `${item.surname || ''} ${item.forename || ''}`,
                  }))}
                  placeholder="Zákazník"
                  simpleValue
                  isDisabled={(personsValue || []).length > 0}
                />
              )}
            />
          </Grid>
                )*/}

        {/*<Grid item xs={12}>
          <FormControlLabel
            control={<Field name="isStocked" component={Checkbox} />}
            label="Zboží ze skladu"
          />
              </Grid>*/}
        {/*!itemsValue && isStocked && (
          <Grid item xs={12}>
            <Grid container justify="flex-start">
              <Grid item xs={3}>
                <FormControl style={{ minWidth: 200, marginTop: 20 }}>
                  <InputLabel htmlFor={'addNewItem'}>Vyberte kategorii</InputLabel>
                  <Field
                    name={'addNewItem'}
                    component={Select2}
                    placeholder={'Vyberte kategorii'}
                    displayEmpty
                  >
                    {get(categories, 'items', []).map((item2) => (
                      <MenuItem key={item2.id} value={item2.id}>
                        {item2.name}
                      </MenuItem>
                    ))}
                  </Field>
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Button
                  style={{ marginTop: 30 }}
                  variant="outlined"
                  onClick={() => {
                    const itemValue = get(itemsValue, `${addNewItem}`);
                    change(`items.${addNewItem}[${itemValue ? itemValue.length : 0}]`, null);
                    loadItems(addNewItem);
                  }}
                >
                  Přidat
                </Button>
              </Grid>
            </Grid>
          </Grid>
                )*/}
        {isStocked && (
          <Grid item xs={12}>
            {get(categories, 'items', []).map((category) => {
              const itemsToShow = get(itemsValue, `${category.id}`, []);
              if (itemsToShow.length > 0) {
                return itemsToShow.map((item, i) => {
                  return (
                    <React.Fragment key={`${category.id}_${i}`}>
                      <Grid container justify="flex-start">
                        <Grid item xs={4}>
                          <Autocomplete
                            name={`items.${category.id}[${i}].item`}
                            placeholder="Vyberte"
                            options={items.map((item2) => ({
                              label: item2.label,
                              value: item2,
                            }))}
                            label={category.name}
                          />
                        </Grid>
                      </Grid>
                    </React.Fragment>
                  );
                });
              } else {
                return null;
              }
            })}
          </Grid>
        )}
        <Grid item xs={3}>
          <Field
            name="customerName"
            component={TextField}
            label="Jméno"
            className={classes.textFields}
            fullWidth
            validate={[required]}
          />
        </Grid>
        <Grid item xs={12}>
          <Field
            name="completionDate"
            component={TextField}
            label="Do"
            className={classes.textFields}
            type="datetime-local"
            InputLabelProps={{
              shrink: true,
            }}
            validate={[required]}
          />
        </Grid>
        {/*
        0001 = rychly servis
        0010 = klasicky servis
        0100 = servis (maly, velky, brouseni ... )
        1000 = serizeni 
        */}
        <Grid item xs={12}>
          <Grid item xs={3}>
            <FormControl style={{ minWidth: 200 }}>
              <InputLabel htmlFor={'serviceId'}>Typ servisu</InputLabel>
              <Field
                name={`serviceId`}
                component={Select2}
                placeholder={'serviceId'}
                //validate={[required]}
                onChange={(f, value) => {
                  change('serviceAttributes', null);
                }}
              >
                {servicesToShow.map((item2) => (
                  <MenuItem key={item2.id} value={item2.id}>
                    {item2.name}
                  </MenuItem>
                ))}
              </Field>
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              {serviceId &&
                serviceId === 9 &&
                Object.keys(get(find(config, { serviceId: 9 }), 'attributes', [])).map((attr) => {
                  if (!['structureType', 'variableAngle'].includes(attr)) {
                    return (
                      <Grid item xs={2} key={attr}>
                        <FormControl style={{ minWidth: 200 }}>
                          <InputLabel htmlFor={attr}>
                            {attr === 'grindingAngle' ? 'Úhel brusu' : 'Úhel podbrusu'}
                          </InputLabel>
                          <Field
                            name={`serviceAttributes.${attr}`}
                            component={Select2}
                            placeholder={attr}
                            validate={[required]}
                          >
                            {get(find(config, { serviceId: 9 }), `attributes.${attr}`, []).map(
                              (item2) => (
                                <MenuItem key={item2.id} value={item2.id}>
                                  {item2.val}
                                </MenuItem>
                              )
                            )}
                          </Field>
                        </FormControl>
                      </Grid>
                    );
                  } else {
                    return null;
                  }
                })}
              <Grid item xs={12}>
                {/* musí existovat služba s flags 11 */}
                <FormControlLabel
                  control={<Field name="adjustment" component={Checkbox} />}
                  label="Seřízení vázání a diagnostika"
                />
              </Grid>
              {adjustment && (
                <React.Fragment>
                  {Object.keys(configQR || {}).map((attr) => {
                    if (!['attributeMapping', 'suffix'].includes(attr)) {
                      return (
                        <Grid key={attr} item xs={3}>
                          <FormControl style={{ minWidth: 200 }}>
                            <InputLabel htmlFor={attr}>
                              {get(
                                configQR,
                                `attributeMapping.${attr.slice(0, -3)}`,
                                attr === 'skillArr' ? 'Lyžařské zkušenosti' : attr
                              )}
                            </InputLabel>
                            <Field
                              name={`itemAdjustment.${attr.slice(0, -3)}`}
                              component={Select2}
                              placeholder={attr}
                              validate={[required]}
                            >
                              {get(configQR, attr, []).map((item2) => (
                                <MenuItem key={item2.id} value={item2.id}>
                                  {['heightArr', 'shoeLengthArr'].includes(attr)
                                    ? `${item2.min} - ${item2.max}`
                                    : item2.val}
                                </MenuItem>
                              ))}
                            </Field>
                          </FormControl>
                        </Grid>
                      );
                    } else {
                      return null;
                    }
                  })}
                  <Grid item xs={3}>
                    <Field
                      name="itemAdjustment.skiLength"
                      component={TextField}
                      label="Délka lyží"
                      className={classes.textFields}
                      type="number"
                      fullWidth
                      validate={[required]}
                    />
                  </Grid>
                </React.Fragment>
              )}
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={6}>
          <Field
            name="note"
            component={TextField}
            label="Poznámka"
            className={classes.textFields}
            fullWidth
          />
        </Grid>

        <Grid item xs={12}>
          <Button type="submit" variant="contained" color="primary" className={classes.submit}>
            Uložit
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              handleTabChange('', 'list');
            }}
          >
            Zrušit
          </Button>
        </Grid>
      </Grid>
    </form>
  )
);



// WEBPACK FOOTER //
// ./src/modules/item-services/form/addForm.js